import Vue from "vue";

export default {
  async getAll() {
    return  (await Vue.http.get(`/api/games`)).data;
  }
}



// WEBPACK FOOTER //
// ./_common/services/game.service.js